import { render } from "./rightBar1.vue?vue&type=template&id=a1799baa"
import script from "./rightBar1.vue?vue&type=script&lang=js"
export * from "./rightBar1.vue?vue&type=script&lang=js"
script.render = render

export default script